import React from 'react';

import './index.scss';

// eslint-disable-next-line react/prop-types
export default function ButtonText({ children }) {
  return (
    <div className="button-text">{ children }</div>
  );
}
